import { useState } from 'react';
import { api, type Me } from '../lib/api.js';

const TABLES = [5, 6, 7, 8, 9, 10];
const GOALS = [10, 20, 30, 50];
const HOURS = [-1, 16, 17, 18, 19, 20];

export function Profile({ me, onSaved }: { me: Me; onSaved: () => void }) {
  const [s, setS] = useState(me.settings);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const save = async (patch: Partial<Me['settings']>) => {
    setS({ ...s, ...patch });
    setSaving(true);
    setError(null);
    try {
      setS(await api.saveSettings(patch));
      onSaved();
    } catch (e) {
      setError(e instanceof Error ? e.message : 'Не удалось сохранить');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="stack">
      <h1>Настройки</h1>

      <div className="card">
        <h3>До какого числа</h3>
        <p className="small dim" style={{ margin: '2px 0 10px' }}>
          Начинать проще с таблицы до 5, а расширять по мере уверенности.
        </p>
        <div className="row wrap">
          {TABLES.map((t) => (
            <button
              key={t}
              className={s.maxTable === t ? 'btn' : 'btn ghost'}
              style={{ flex: '1 1 60px', minHeight: 44 }}
              onClick={() => void save({ maxTable: t })}
            >
              до {t}
            </button>
          ))}
        </div>
      </div>

      <div className="card">
        <div className="row between">
          <span>
            <h3>Примеры на деление</h3>
            <span className="small dim">56 ÷ 7 вперемешку с умножением</span>
          </span>
          <button
            className={s.division ? 'btn' : 'btn ghost'}
            style={{ minWidth: 78 }}
            onClick={() => void save({ division: !s.division })}
          >
            {s.division ? 'вкл' : 'выкл'}
          </button>
        </div>
      </div>

      <div className="card">
        <h3>Цель на день</h3>
        <div className="row wrap" style={{ marginTop: 10 }}>
          {GOALS.map((g) => (
            <button
              key={g}
              className={s.dailyGoal === g ? 'btn' : 'btn ghost'}
              style={{ flex: '1 1 60px', minHeight: 44 }}
              onClick={() => void save({ dailyGoal: g })}
            >
              {g}
            </button>
          ))}
        </div>
      </div>

      <div className="card">
        <h3>Напоминание</h3>
        <p className="small dim" style={{ margin: '2px 0 10px' }}>
          Бот напишет, если к этому часу задание дня ещё не выполнено.
        </p>
        <div className="row wrap">
          {HOURS.map((h) => (
            <button
              key={h}
              className={s.reminderHour === h ? 'btn' : 'btn ghost'}
              style={{ flex: '1 1 62px', minHeight: 44 }}
              onClick={() => void save({ reminderHour: h })}
            >
              {h === -1 ? 'выкл' : `${h}:00`}
            </button>
          ))}
        </div>
      </div>

      {saving && <p className="small dim center">Сохраняю…</p>}
      {error && <p className="small center" style={{ color: 'var(--critical)' }}>{error}</p>}
    </div>
  );
}
